import { getSiteIdsForGroups } from "@/utils/store";

const DEFAULT_STATE = {
  sites: [],
  siteGroups: [],
  monthDate: "",

  // Mappings
  mappingEntity: "",
  mappingSource: "",
  mappingSearch: "",
  mappingReplace: "",
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getSiteGroups: (state) => state.siteGroups,
    getMonthDate: (state) => state.monthDate,

    // Mappings
    getMappingEntity: (state) => state.mappingEntity,
    getMappingSource: (state) => state.mappingSource,
    getMappingSearch: (state) => state.mappingSearch,
    getMappingReplace: (state) => state.mappingReplace,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setSiteGroups(state, payload) {
      state.siteGroups = payload;
    },
    setMonthDate(state, payload) {
      state.monthDate = payload;
    },

    // Mappings
    setMappingEntity(state, payload) {
      state.mappingEntity = payload;
    },
    setMappingSource(state, payload) {
      state.mappingSource = payload;
    },
    setMappingSearch(state, payload) {
      state.mappingSearch = payload;
    },
    setMappingReplace(state, payload) {
      state.mappingReplace = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateSites({ commit }, payload) {
      commit("setSites", payload);
    },
    async updateSiteGroups({ commit }, payload) {
      commit("setSiteGroups", payload);

      const site_ids = await getSiteIdsForGroups(payload);
      commit("setSites", site_ids);

      return site_ids;
    },
    updateMonthDate({ commit }, payload) {
      commit("setMonthDate", payload);
    },

    // Mappings
    updateMappingEntity({ commit }, payload) {
      commit("setMappingEntity", payload);
    },
    updateMappingSource({ commit }, payload) {
      commit("setMappingSource", payload);
    },
    updateMappingSearch({ commit }, payload) {
      commit("setMappingSearch", payload);
    },
    updateMappingReplace({ commit }, payload) {
      commit("setMappingReplace", payload);
    },
  },
};
